import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import moment from "moment";

import { useStyles } from "./UserFees.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { url } from "../../../Config/Config";
import CustomEmptyMessage from "../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../Components/CustomSiteLoader/CustomSiteLoader";
import { engMonths } from "../../../Components/Data/Months";
import FeeDetails from "./FeeDetails/FeeDetails";
import BillHeader from "./BillHeader/BillHeader";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import SchoolHeader from "../SchoolHeader/SchoolHeader";

class UserFees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fees: [],
      schoolDetails: {},
      studentDetails: {},
      month: moment(new Date()).format("MMMM"),
    };
  }

  componentDidMount() {
    this.getUserFees();
    this.getSchoolInfo();
  }

  getSchoolInfo = async () => {
    const response = await Axios.get(`${url}/api/setting`, {});
    if (response.data) {
      this.setState({ schoolDetails: response.data });
    }
  };

  getUserFees = async () => {
    try {
      const responseStudent = await Axios.get(
        `${url}/api/students/${this.props.userId}`,
        {
          headers: { Authorization: `Bearer ${this.props.userToken}` },
        }
      );
      this.setState({ studentDetails: responseStudent.data.student });
      const response = await Axios.get(
        `${url}/api/student-fees/${responseStudent.data.student._id}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        }
      );
      if (response.data.studentFees.length !== 0) {
        this.setState({
          fees: response.data.studentFees[0].fees,
          isEmpty: false,
        });
      } else {
        this.setState({
          fees: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserFees();
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { schoolDetails, studentDetails } = this.state;
    let filtered = this.state.fees.filter((filterData) => {
      return filterData.month === this.state.month;
    });
    let total = 0;
    let paid = 0;
    filtered.map((data) => (total = data.price + total));
    filtered.map((data) => data.status && (paid = data.price + paid));
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          {this.state.fees.length !== 0 ? (
            <div>
              <TextField
                name="month"
                select
                required
                fullWidth
                label="Fee Month"
                variant="outlined"
                margin="normal"
                className={classes.inputWithoutMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.month}
                onChange={(e) => this.setState({ month: e.target.value })}
              >
                <option value="">Select Any One</option>
                {engMonths.map((month, index) => (
                  <option value={month} key={index}>
                    {month}
                  </option>
                ))}
              </TextField>
              <div className={classes.sectionDesktop}>
                <br />
                {filtered.length !== 0 ? (
                  <div
                    style={{
                      width: "70%",
                    }}
                  >
                    <BillHeader
                      studentDetails={studentDetails}
                      schoolDetails={schoolDetails}
                      month={this.state.month}
                    />
                    <FeeDetails
                      feeData={filtered}
                      total={total}
                      paid={paid}
                      schoolDetails={this.state.schoolDetails}
                    />
                  </div>
                ) : (
                  <CustomEmptyMessage description="No Bill for this month" />
                )}
              </div>
              <div className={classes.sectionMobile}>
                {filtered.length !== 0 ? (
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <SchoolHeader
                      studentDetails={studentDetails}
                      month={this.state.month}
                    />
                    <FeeDetails
                      feeData={filtered}
                      total={total}
                      paid={paid}
                      schoolDetails={this.state.schoolDetails}
                    />
                  </div>
                ) : (
                  <div>No Bill for this month</div>
                )}
              </div>
            </div>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserFees));
